import { Icon } from '@repo/ui';

import styles from './TinyPlusBadge.module.css';

// Gold "Tiny+" badge shown on exclusive content for recognition — rendered for
// members and non-members alike (the lock UX lives in the featured area).
export const TinyPlusBadge = () => (
  <span className={styles.tinyPlusBadge}>
    <Icon name='awardFilled' size='s' />
    Tiny+
  </span>
);
